const HR : React.FC = () => {
    return (
        <hr 
            style={{
                borderTop: '1px solid #f3f3f6', 
                borderLeft: 'none'
            }}
        />
    )
}


export default HR;